<template>
  <div>
    <!-- <div
      class="table__header"
      style="margin-bottom: 13px !important;margin-top: -12px;"
    >
      <button
        v-if="$route.path.includes('create-order') && getDressColors.length == 0"
        v-b-modal.add-custom
        class="button"
        style="border-radius:6px"
        @click="getMaterialVByMandP"
      >
        <b-icon-plus />
        Add Custom Dress
      </button>
    </div> -->
    <div
      class="toolbar"
      style="height: 62px"
    />
    <div>
      <table
        class="team_table"
        :class="{'button--disabled': getMaterialsByArticleNum.length == 0 }"
      >
        <thead>
          <tr>
            <th>
              {{ $t('StoreName') }}
            </th>
            <th>
              {{ $t('Quantity') }}
            </th>
            <th>
              {{ $t('AddProductCart') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('productsByArticleNumber')"
          :response-data="getMaterialsByArticleNum?.productSingleMaterialVariantDtos"
        >
          <tr
            v-for="item in getMaterialsByArticleNum.productSingleMaterialVariantDtos"
            :key="item.materialVariantId"
            style="cursor: pointer"
          >
            <td>
              {{ item.storeName }}
            </td>
            <td>
              {{ item.quantity }}
            </td>
            <td
              v-b-modal.add-product-cart
              style="text-align: left; cursor: pointer"
              @click="addOneProduct(item)"
            >
              <div>
                <p>
                  <span>
                    <b-icon-cart class="h4" />
                  </span>
                </p>
              </div>
            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>
    </div>
    <AddProductToCart
      :one-product="oneProduct"
      @addOneProductOnly="addOneProductInCart"
    />
    <vue-easy-lightbox
      :esc-disabled="false"
      move-disabled
      :visible="image.visible"
      :imgs="image.imgs"
      :index="image.index"
      @hide="handleHide"
    />
    <!-- <ViewVariantStockLocation /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
import AddProductToCart from '@/components/productsInStock/modals/AddProductToCart.vue'
// import ViewVariantStockLocation from '@/components/products/modals/ViewVariantStockLocation.vue'
// import CreateCustomOrderModal from '@/modals/CreateCustomOrderModal.vue';

export default {
  components: {
    VueEasyLightbox,
    AddProductToCart,
    // ViewVariantStockLocation,
    // eslint-disable-next-line vue/no-unused-components
    // CreateCustomOrderModal,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    productMatObj: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    addedArticle: {
      type: Array,
    },
    createOrder: {
      type: Boolean,
    },
    inventoryProductsOfId: {
      type: String,
    },
    articleNumberOfProduct: {
      type: String,
    },
  },
  data() {
    return {
      showStockLocation: false,
      showPopup: {},
      dummy: '',
      searchTerm: '',
      rows: [],
      idOfArticle: '',
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      oneProduct: null,
    };
  },
  computed: {
    ...mapGetters(['getMaterialsByArticleNum', 'getDressColors', 'getCurrentStockAmountByLocation']),
  },
  watch: {
    productMatObj() {
      this.addRows();
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    ...mapActions(['getCurrentStockAndLocationByVariantId', 'addOrderInStore', 'productsByArticleNumber', 'getMaterialVariantsToMDCPagination', 'updatePatternTime', 'updateEmbroideryTime', 'updateSewingTime']),
    async updateTimeMinus(type, value) {
      if (type == 'pattern') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.patternInMinutes - 1;
        }
        await this.updatePatternTime({
          inventoryId: this.inventoryProductsOfId,
          newPatternTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'sewing') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.sewingInMinutes - 1;
        }
        await this.updateSewingTime({
          inventoryId: this.inventoryProductsOfId,
          newSewingTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'embroidery') {
        let newTime
        if (value == null) {
          newTime = 0 - 1;
        } else {
          newTime = value.embroideryInMinutes - 1;
        }
        await this.updateEmbroideryTime({
          inventoryId: this.inventoryProductsOfId,
          newEmbroideryTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      }
    },
    async updateTime(type, value) {
      console.log('type', type)
      if (type == 'pattern') {
        let newTime
        if (value == null) {
          newTime = 0 + 1;
        } else {
          newTime = value.patternInMinutes + 1;
        }
        await this.updatePatternTime({
          inventoryId: this.inventoryProductsOfId,
          newPatternTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'sewing') {
        let newTime
        if (value == null) {
          newTime = 0 + 1;
        } else {
          newTime = value.sewingInMinutes + 1;
        }
        await this.updateSewingTime({
          inventoryId: this.inventoryProductsOfId,
          newSewingTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      } else if (type == 'embroidery') {
        let newTime
        if (value == null) {
          newTime = 0 + 1;
        } else {
          newTime = value.embroideryInMinutes + 1;
        }
        await this.updateEmbroideryTime({
          inventoryId: this.inventoryProductsOfId,
          newEmbroideryTime: newTime,
          successCallback: () => {
            this.productsByArticleNumber(this.articleNumberOfProduct);
          },
        });
      }
    },
    toggleStockLocation(id, event) {
      event.stopPropagation(); // Prevents the click from closing the popup immediately
      this.showPopup = { ...this.showPopup, [id]: !this.showPopup[id] };
      if (this.showPopup[id]) {
        this.stockLocationDetails({ materialVariantId: id });
      } else {
        this.hideStockLocation();
      }
    },
    stockLocationDetails(value) {
      this.materialVariantId = value.materialVariantId
      this.showStockLocation = true
      this.getCurrentStockAndLocationByVariantId({ materialVariantId: value.materialVariantId })
    },
    hideStockLocation() {
      this.showStockLocation = false
    },
    handleClickOutside(event) {
      const popup = this.$el.querySelector('.popup');
      if (popup && !popup.contains(event.target)) {
        this.showPopup = {}; // Close all popups
      }
    },
    matProps(value) {
      this.materialVariantId = value.materialVariantId
      console.log('MaterialVariantId', this.materialVariantId)
      console.log('Getter', this.getCurrentStockAmountByLocation)
      this.getCurrentStockAndLocationByVariantId({ materialVariantId: value.materialVariantId })
    },

    async getAllImages(item) {
      console.log('itemi', item)
      this.image.imgs = [];
      this.image.imgs.push({
        src: item.fileUrl,
      });
      this.show();
    },
    show() {
      this.image.visible = true
    },

    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },
    addOneProductInCart(value) {
      this.addItemsArticleCart({
        storeId: this.oneProduct.storeId,
        object: [value],
        successCallback: () => {
          this.selectAll = false
          this.orderItemIds = []
          this.itemIsAlreadyOnCart = '';
        },
      })
    },
    addOneProduct(value) {
      this.oneProduct = value
      this.isArticleOnCart({
        storeId: value.storeId,
        inventoryProductId: value.inventoryProductId,
      });
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    async createCustomOrder(obj) {
      await this.addOrderInStore(obj);
    },
    getStyle() {
      if (this.getDressColors.length != 0) {
        return 'margin-top: 112px'
      // eslint-disable-next-line no-else-return
      } else {
        return 'margin-top: 112px'
      }
    },
    addRows() {
      const x = this.productMatObj.productMaterialVariantDtos;
      const y = this.productMatObj.productMaterialQuantityDtos;

      this.rows = [...x, ...y];
    },

    // tdClass(row) {
    //   return row.vgtSelected ? 'row-clicked' : '';
    // },

    // onRowClick(p) {
    //   return p.selected ? 'selected' : '';
    // },
    async getMaterialVByMandP() {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      });
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  width: 270px;
  height: auto;
  border-radius: 8px;
  border: 1px solid lightgray;
  background: white;
  position: absolute;
  top: calc(100% - 10px);
  left: 88%;
  transform: translateX(-50%);
  z-index: 1;
}

.actiontd {
  position: relative;
}
.minutes{
  display: flex;
  gap:4px;
}
.insideProductTable {
  width: 60%;
  // padding-top: 16px
}
.team_table td {
  padding: 16px 10px !important;
}

.team_table th {
  padding: 10px;
}

.team_table th:first-child {
  border-radius: 0px 0px 0px 0px;
}

.team_table th:last-child {
  border-radius: 0px 0px 0px 0px;
}
.orange-color {
  color: orange;
}
.red-color {
  color: red;
}
.green-color {
  color: green;
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}


@media screen and (max-width: 1823px) {
  .inside-product__wrapper{
    margin-left: 20px;
  }
  .inside-product__wrapper2{
    width:100% !important;
  }
}
@media screen and (max-width: 1623px) {
  .inside-product__wrapper{
    margin-left: 20px;
  }
  .inside-product__wrapper2{
    width:100% !important;
  }
}
@media screen and (max-width: 1400px) {
.inside-product__wrapper{
  width: 200px !important;
  margin-left: 0px !important;
  // button{
  //   font-size: 11px;
  //   width: 100% !important;
  //   height: 36px;
  // }
}
.inside-product__wrapper2{
    width:100% !important;
  }
  .insideProductTable {
    width: 100%;
  }
  .popup {
    width: 270px;
    height: auto;
    border-radius: 8px;
    border: 1px solid lightgray;
    background: white;
    position: absolute;
    top: calc(100% + 0px); /* Adjust this value based on your design */
    left: 25%;
    transform: translateX(-50%);
    z-index: 1;
  }
}

@media screen and (max-width: 1200px) {
  .inside-product__wrapper2 {
    margin-top: 30px !important;
    width: 100%;
  }
  .insideProductTable {
    width: 100%;
  }
}
@media screen and (max-width: 896px) {
  .inside-product__wrapper {
    width: auto !important;
    flex-basis: 50%;
  }
}
</style>
